module.exports = __webpack_public_path__ + "static/media/reloj_verde.f9f5b485.svg";